import reducer from './reducer';
import Notifications from './notifications';
import { addNotification, removeNotification } from './actions';

export {
  reducer,
  addNotification,
  removeNotification
};

export default Notifications;
